import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeGuard } from 'src/app/guards/home.guard';
import { UserResolver } from 'src/app/resolvers/user.resolver';
import { FeedPage } from './feed.page';

const routes: Routes = [
  {
    path: '',
    component: FeedPage,
    resolve: {
      user: UserResolver,
    },
  },
  {
    path: 'indicated',
    canActivate: [HomeGuard],
    loadChildren: () =>
      import('./indicated/indicated.module').then((m) => m.IndicatedPageModule),
  },
  {
    path: 'plans',
    canActivate: [HomeGuard],
    loadChildren: () =>
      import('./plans/plans.module').then((m) => m.PlansPageModule),
  },
  {
    path: 'partners',
    canActivate: [HomeGuard],
    loadChildren: () =>
      import('./partners/partners.module').then((m) => m.PartnersPageModule),
  },
  {
    path: 'withdraw',
    canActivate: [HomeGuard],
    loadChildren: () =>
      import('./withdraw/withdraw.module').then((m) => m.WithdrawPageModule),
  },
  {
    path: 'extract',
    canActivate: [HomeGuard],
    loadChildren: () =>
      import('./extract/extract.module').then((m) => m.ExtractPageModule),
  },
  {
    path: 'transfer',
    canActivate: [HomeGuard],
    loadChildren: () =>
      import('./transfer/transfer.module').then((m) => m.TransferPageModule),
  },
  {
    path: 'pay',
    canActivate: [HomeGuard],
    loadChildren: () => import('./pay/pay.module').then((m) => m.PayPageModule),
  },
  {
    path: 'payment-link/:hash',
    canActivate: [HomeGuard],
    loadChildren: () => import('./pay/pay.module').then((m) => m.PayPageModule),
  },
  {
    path: 'receive',
    canActivate: [HomeGuard],
    loadChildren: () =>
      import('./receive/receive.module').then((m) => m.ReceivePageModule),
  },
  {
    path: 'cashback',
    canActivate: [HomeGuard],
    loadChildren: () =>
      import('./cashback/cashback.module').then((m) => m.CashbackPageModule),
  },
  {
    path: 'recurrent',
    canActivate: [HomeGuard],
    loadChildren: () =>
      import('./recurrent/recurrent.module').then((m) => m.RecurrentPageModule),
  },
  {
    path: 'lending',
    canActivate: [HomeGuard],
    loadChildren: () =>
      import('./lending/lending.module').then((m) => m.LendingPageModule),
  },
  {
    path: 'investment',
    canActivate: [HomeGuard],
    loadChildren: () =>
      import('./investment/investment.module').then(
        (m) => m.InvestmentPageModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FeedPageRoutingModule {}
